









import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Price extends Vue {
    @Prop({ required: true }) price!: EstatePrice;

    @Prop({ default: "available" }) status!: string;

    @Prop({ default: "sale" }) negotiation!: string;

    @Prop({ default: "€" }) sign!: "€" | "EUR";

    @Prop({ default: "text-14 text-white bg-brand px-12 py-4" }) labelClass!: string;

    get computedPrice() {
        let prefix: string = "";
        let suffix: string = "";
        const price: string = `${this.price.amount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        if (this.price.currency === "EUR" && this.sign === "€") {
            prefix = "€";
        }
        if (this.price.currency === "EUR" && this.sign === "EUR") {
            suffix = "euro";
        }

        if (this.negotiation === "sale") {
            return `${prefix} ${price} ${suffix}`;
        } else {
            return `${prefix} ${price} ${suffix} <span style="font-family:auto;">/</span> maand`;
        }
    }
}
